import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext } from 'react';
export class CloudWatchRum {
    constructor() {
        // TODO: Add queuing logic to buffer events if cwr loads after initial check.
        // In most cases, cwr should be immediately available when the app loads.
        // Set up a timeout to check again and log if not available
        setTimeout(() => {
            if (typeof window.cwr === 'undefined') {
                console.warn('Cloudwatch not initialized.');
            }
        }, 5000);
    }
    recordEvent(eventType, eventData) {
        if (typeof window.cwr !== 'undefined') {
            window.cwr('recordEvent', { type: eventType, data: eventData });
        }
    }
    addSessionAttributes(sessionAttributes) {
        if (typeof window.cwr !== 'undefined') {
            window.cwr('addSessionAttributes', sessionAttributes);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    recordError(error) {
        if (typeof window.cwr !== 'undefined') {
            window.cwr('recordError', error);
        }
    }
}
const defaultRumClient = new CloudWatchRum();
export const AnalyticsContext = createContext(defaultRumClient);
// For ease of testing
export const useAnalyticsContext = () => React.useContext(AnalyticsContext);
export const AnalyticsProvider = ({ children }) => {
    return _jsx(AnalyticsContext.Provider, { value: defaultRumClient, children: children });
};
